export default "/images/88760ccccd10fc7747223cb859ace94a.avif";